<template>
  <error title="404" content="未找到该页面"></error>
</template>
<script>
import error from './error'
export default {
  name: "not-found",
  components:{error}
};
</script>



// WEBPACK FOOTER //
// src/components/common/404.vue